import api from './api';  // uses your configured Axios instance

const fetchHistoricalData = async ({ ticker, date_start, date_end }) => {
  try {
    const response = await api.put('/historical_data', {
      ticker,
      date_start,
      date_end,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching historical data:', error);
    return null;
  }
};

export default fetchHistoricalData;
